module.exports = __webpack_public_path__ + "6b90a447f24a5e18b8ac4f12d8637fd9.svg";